export type ISort = {
    field: string;
    sort: 'asc' | 'desc';
    seed?: number;
};

export enum IProcStatus {
    Pending = 0,
    Processing = 1,
    Completed = 2,
    Failed = 3,
}

export enum TimePeriod {
  TODAY = 'Today',
  PAST_WEEK = 'Past week',
  PAST_MONTH = 'Past month',
  PAST_3_MONTHS = '3 months',
  ALL_TIME = 'All time',
}